import { createFileRoute } from '@tanstack/react-router';
import { AcceptableUsePage } from '../../pages/AcceptableUsePage';
import { staticPageHead } from '../../lib/seo/staticPageHead';

export const Route = createFileRoute('/_site/acceptable-use')({
  head: () =>
    staticPageHead({
      path: '/acceptable-use',
      title: 'Acceptable Use Policy - AnyAPI',
      description:
        'What you may and may not do with the AnyAPI gateway: lawful data collection, platform abuse limits, and respect for the people whose data passes through.',
      crumb: 'Acceptable Use Policy',
    }),
  component: AcceptableUsePage,
});
